export const HOME_ROUTE = "/{service_company_slug}/"
